import React from 'react';
import Header from '../navbar/Header';
import Container from '../Container';
import Content from '../Content';
import Navbar from '../navbar/Navbar';
import TableMarket from './TableMarket';


function TableListMarket(props) {
    return (
        <Container>
        <Navbar/>

        <Content>
           <Header/>
          
         <div className='container-fluid'>
            <div className='row'>
            <TableMarket/>
            </div>
         </div>
        </Content>
       

      </Container>
    );
}

export default TableListMarket;